import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function CurrentUsersChart() {
  const data = {
    labels: ['Web', 'Mobile', 'Tablet'],
    datasets: [
      { data: [62, 28, 10], backgroundColor: ['#4c84ff', '#80e1c1', '#ff7b7b'], borderWidth: 0 },
    ],
  };
  const options = { responsive: true, maintainAspectRatio: false, plugins: { legend: { position: 'bottom' } } };
  return (
    <div style={{ height: 240 }}>
      <Doughnut data={data} options={options} />
    </div>
  );
}

export default CurrentUsersChart;


